module.exports = __webpack_public_path__ + "static/media/domainActive.5ece9582.svg";